import { render } from "./CRAInfo.vue?vue&type=template&id=cf478318&scoped=true"
import script from "./CRAInfo.vue?vue&type=script&lang=js"
export * from "./CRAInfo.vue?vue&type=script&lang=js"

import "./CRAInfo.vue?vue&type=style&index=0&id=cf478318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf478318"]])

export default __exports__